import { GridRowData } from '@mui/x-data-grid-pro';

import { ProductApi } from 'common/types';
import { ProductVariant } from 'common/modules/inventory/types';
import { STATIC_COLUMNS } from './columns';
import { getProductNameWithVariant } from 'common/utils/productUtils';

const { VARIANT } = STATIC_COLUMNS;

export interface VariantsRowData extends GridRowData {
	id: string;
	[VARIANT]: string;
}

export const getVariantsRows = (
	options: ProductVariant[],
	product: ProductApi,
): VariantsRowData[] => {
	return options.map((o) => {
		const variantName = getProductNameWithVariant(product.name.def, o, 'def');
		return {
			id: o.id,
			[VARIANT]: variantName,
			...Object.entries(o.values).reduce((acc, [key, value]) => {
				acc[key] = value.def;
				return acc;
			}, {}),
		};
	});
};
